// 组件全局注册
import Vue from 'vue'

import SmHeader from './sm_header/index'
import SmFooter from './sm_footer/index'
import SmCell from './sm_cell/index'
import SmCard from './sm_card/index'


// 形成组件库
const components = [
    SmHeader,
    SmFooter,
    SmCell,
    SmCard,
]

// 注册全局组件
components.map((com) =>{
    Vue.use(com)
})

export default components


//////////////////
// WEBPACK FOOTER
// ./node_modules/smart_webview_ui/src/components/install.js
// module id = null
// module chunks = 